export enum ProjectionIndicatorType {
  is = 'is',
  isBalance = 'is_balance',
  socialChargesBalance = 'social_charges_balance',
  cashBalance = 'cash_balance',
  loanBalance = 'loan_balance',
  immobilisationBrute = 'immobilisation_brute',
  compteCourantBalance = 'compte_courant_balance',
  totalPrelevementTns = 'total_prelevement_tns',
  totalRemunerationTns = 'total_remuneration_tns',
  projectedDividends = 'projected_dividends',
  ratioEbe = 'ratio_ebe',
  ratioNetResult = 'ratio_net_result'
}
